import { PLACES_TO_VISIT_SLUGS } from 'Constants/constants';

export const getPlacesToVisitSlug = (lang = 'en') =>
	PLACES_TO_VISIT_SLUGS[lang.toUpperCase()];
